/**
 * Validates that a URL uses a safe protocol (http or https).
 * Returns the URL if safe, or null if potentially malicious (e.g., javascript:).
 */
export const getSafeUrl = (url) => {
  if (!url || typeof url !== 'string') return null;
  try {
    const parsed = new URL(url, window.location.origin);
    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
      return url;
    }
    return null;
  } catch {
    return null;
  }
};

// Raster image data URIs that are safe to use as an <img> src. SVG is excluded
// because it can carry script when opened directly.
const SAFE_IMAGE_DATA_URI = /^data:image\/(png|jpe?g|gif|webp);base64,[a-z0-9+/=\s]+$/i;

/**
 * For <img src> values that come from scan evidence, which is attacker-influenced: a
 * remote image URL would make the viewer's browser contact a third party just by
 * expanding a finding. Allow only base64 raster data URIs and same-origin URLs.
 */
export const getSafeImageUrl = (url) => {
  if (typeof url !== 'string' || !url) return null;
  if (SAFE_IMAGE_DATA_URI.test(url)) return url;
  try {
    const parsed = new URL(url, window.location.origin);
    if (parsed.origin === window.location.origin && getSafeUrl(url)) return url;
  } catch {
    // fall through
  }
  return null;
};
